import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
import { startSpinner, finishSpinner } from "./ui/spinner";
import { startAlerta } from "./ui/alertas";
import { handleErrorApi } from "../helpers/randoms";
import { setAfiliadoSeleccionado } from "./certificadoAtencion/certificadoAtencionActions";


const afiliadoExternoUpdated = (afiliado) => ({
  type: types.afiliacionesAfiliadoUpdated,
  payload: afiliado,
});

const afiliadoExternoRecetasUpdated = (afiliado) => ({
  type: types.recetasDigitalesUpdateAfiliadoSeleccionado,
  payload: afiliado,
});

export const afiliadoExternoStartUpdate = (afiliado, idObraSocial, paraTurnos = true) => {
  return async (dispatch, getState) => {
    try {
      dispatch(startSpinner());
      afiliado.idObraSocial = idObraSocial;
      
      //const afiliadoPreparado = await prepareBeneficiarios(afiliado);
      const response = await fetchConToken(`AfiliadosExternos`, /*afiliadoPreparado*/afiliado, 'POST');
      const respuesta = await response.json();
      if (response.status !== 200) throw respuesta.errores;
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          dispatch(startAlerta(`${afiliado.apellido_y_nombre} Actualizado correctamente`, 'success', 'Comando Exitoso'));
          afiliado.idAfiliado = respuesta.idAfiliadoExterno;
          afiliado.idGrupoFamiliar = respuesta.idGrupoFamiliar;
          afiliado.externo = true;
          afiliado.id_afiliado = respuesta.idAfiliadoExterno;
          afiliado.idAfiliadoExterno = respuesta.idAfiliadoExterno;
          afiliado.carnet = respuesta.carnet;
          if (paraTurnos) {
            dispatch(afiliadoExternoUpdated(afiliado));
          } else {
            dispatch(afiliadoExternoRecetasUpdated(afiliado));
          }
          //dispatch(evaluarDocumentacionAfiliado());
          //dispatch(fetchGrupoFamiliar(afiliado.id_afiliado));
        } else {
          throw response.errores;
        }
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err.mensaje, "warning", `¡Error!`));
    }
  };
};

export const getObrasSociales = () => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await fetchConToken(`ObrasSociales`);
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.afiliacionesSetObrasSocialesSuccess,
          payload: body
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.afiliacionesSetObrasSocialesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener la lista de obras sociales",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const getDatosPreviosDeAfiliadoExterno = (idObraSocial, afiliado, paraTurnos = true, setearValoresDeAfiliado = null) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const result = await fetchConToken(`AfiliadosExternos/ObtenerDatosPrevios/${idObraSocial}/${afiliado.nro_doc}`);
      const body = await result.json();
      debugger
      if (result.ok) {
        if (paraTurnos) {
          dispatch(afiliadoExternoUpdated(body));
          dispatch(setAfiliadoSeleccionado(body));
        } else {
          //setearValoresDeAfiliado && setearValoresDeAfiliado(body);
          dispatch(afiliadoExternoRecetasUpdated(body));
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener info actualizada del afiliado",
        ""
      );
    }
  };
};
